/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import { SET_TOUR_TIME_FILTER } from '../actions/filtersActions.js';
import { filterTimesBySelectedTimes } from '../utils/tourTimeUtils';

import {
    SET_FETCH_TOUR_TIMES_STATUS,
    FETCH_TOUR_TIMES_SUCCESS,
    FETCH_TOUR_TIMES_ERROR,
    CLEAR_TOUR_TIMES,
    FETCH_TOUR_TIMES,
} from '../actions/tourTimesActions';

export const initialState = {
    date: null,
    data: {},
    loadingStatus: STATUS.IDLE,
    isLoading: true,
    filteredTourTimes: {},
};

export const tourTimesReducers = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TOUR_TIMES:
            return {
                ...state,
                isLoading: true,
            };
        case SET_FETCH_TOUR_TIMES_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_TOUR_TIMES_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        case FETCH_TOUR_TIMES_ERROR:
            return {
                ...state,
                date: null,
                filteredTourTimes: null,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        case CLEAR_TOUR_TIMES:
            return initialState;
        case SET_TOUR_TIME_FILTER:
            return {
                ...state,
                filteredTourTimes: filterTimesBySelectedTimes({
                    tourTimesById: state.data,
                    tourTimeFilter: action.payload,
                }),
            };
        default:
            return state;
    }
};
